module.exports = __webpack_public_path__ + "media/theme/zigzag-e0f361e1.png";